import { QcConversationForListSchema } from "./QcConversationForList";
import { z } from "zod";

export type ModelConversationListForConversationList = z.infer<typeof ModelConversationListForConversationListSchema>;
export const ModelConversationListForConversationListSchema = z.object({
  items: z.array(QcConversationForListSchema),
  nextPage: z.number().nullable(),
});
